import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

interface AdminProtectedRouteProps {
    children: React.ReactElement;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        // запрос к защищённому эндпоинту для проверки токена администратора
        axios
            .get(`${process.env.REACT_APP_SERVER_URL}/admin/protected`, { withCredentials: true })
            .then((response) => {
                setIsAuthenticated(true);
            })
            .catch((error) => {
                setIsAuthenticated(false);
            })
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div>Загрузка...</div>;
    if (!isAuthenticated) return <Navigate to="/admin/login" />;
    return children;
};

export default AdminProtectedRoute;
